import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_cycle_hdr_RowClass} from '../../../dbschema';

export class ClaimCycleHdrContainerModel extends BaseContainerModel {
  bl_aat_claim_cycle_hdr: bl_aat_claim_cycle_hdr_RowClass = new bl_aat_claim_cycle_hdr_RowClass();
}
